import { LayoutNesting } from "#modules/layouts/infra/LayoutNesting.dto";

type Params = {
  layoutNesting: LayoutNesting | undefined | null;
};

export const getMaxNumberOfItemsPerPanel = ({ layoutNesting }: Params) => {
  if (!layoutNesting) {
    return 0;
  }

  const usedItems = layoutNesting.items.filter((item) => item.type === "used");

  const itemsByPanel = usedItems.reduce(
    (acc, item) => {
      if (!acc[item.panel]) {
        acc[item.panel] = [];
      }
      acc[item.panel]?.push(item);

      return acc;
    },
    {} as Record<string, LayoutNesting["items"]>,
  );

  const maxItemsInPanel = Math.max(...Object.values(itemsByPanel).map((items) => items.length));

  return maxItemsInPanel;
};
